/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  FileInfo,
  FileInfoResponse,
  PayloadOriginFile,
  StreamFile,
  UpdateModelIdPayload,
} from "@/common/define";
import { SystemConstants } from "@/common/system-constants";
import { Observable } from "rxjs/internal/Observable";
import { map, tap } from "rxjs/operators";
import { ajax, AjaxResponse } from "rxjs/ajax";
import HttpClient from "./http-client";
import { APIHosts, ApiReduxHelpers } from "./reduxHelpers";
import Utils from "@/utils/utils";
import { StatusTask } from "@/store/uploadFiles/uploadFileSlice";

export interface ConvertOptions {
  convert3DModel: 0 | 1;
  convert2DSheet: 0 | 1;
  extractProperties: 0 | 1;
  childModels: 0;
}

export interface ConvertFilePayload {
  filename: string;
  originalFilePath?: string;
  convertOptions: ConvertOptions;
  downloadUrl?: string;
  baseFileId: string;
  baseMajorRev: number;
  baseMinorRev: number;
}

export interface TaskLog {
  id: string;
  taskId: string;
  log: string;
  createTime: string;
  action: string;
  type: string;
  message: string;
}

class ConversionApiController extends ApiReduxHelpers {
  constructor() {
    super();
  }
  ApiHost = APIHosts.Conversion;

  getCacheByListFile(
    data: PayloadOriginFile[]
  ): Observable<FileInfoResponse[]> {
    const url = `${this.getHost(this.ApiHost)}/${
      SystemConstants.SERVER_CONVERSION.API.CACHE.GET_LIST_FILE
    }`;

    return HttpClient.post(url, data).pipe(
      map((res) => res as FileInfoResponse[])
    );
  }

  updateModelId(data: UpdateModelIdPayload): Observable<number> {
    const url = `${this.getHost(this.ApiHost)}/${
      SystemConstants.SERVER_CONVERSION.API.CACHE.UPDATE_MODEL_FILE_ID
    }`;

    return HttpClient.put(url, data).pipe(map((res) => res as number));
  }

  getAllCache(): Observable<any[]> {
    const url = `${this.getHost(this.ApiHost)}/${
      SystemConstants.SERVER_CONVERSION.API.CACHE.GET_ALL
    }`;

    return HttpClient.get(url).pipe(map((res) => res as any[]));
  }

  cacheFile(data: StreamFile) {
    const path = "?overwrite=true&ignore_line_weight=1";
    const url = `${this.getHost(this.ApiHost)}/${
      SystemConstants.SERVER_CONVERSION.API.CACHE.GET
    }${path}`;

    return HttpClient.post(url, data).pipe(
      map((res) => res as FileInfoResponse)
    );
  }

convertFileByProject(
  projectName: string,
  data: ConvertFilePayload,
  overwrite = true
): Observable<FileInfoResponse> {
      const path = `?overwrite=${overwrite}&project=${encodeURIComponent(
      projectName
    )}`;
      const url = `${this.getHost(this.ApiHost)}/${
      SystemConstants.SERVER_CONVERSION.API.CACHE.CONVERT
    }${path}`;
  return ajax.post(url, data).pipe(
    map((res) => res.response as FileInfoResponse)
  );
}

  getTaskByBaseFileId(baseFileId: string): Observable<StatusTask> {
    const url = `${this.getHost(this.ApiHost)}/${SystemConstants.SERVER_CONVERSION.API.CACHE.GET_TASK}?basefileid=${baseFileId}`;
    return HttpClient.get(url).pipe(
      map((res) => res as StatusTask)
    );
  }

  getTaskLogByTaskId(taskId: string): Observable<TaskLog[]> {
  const url = `${this.getHost(this.ApiHost)}/${SystemConstants.SERVER_CONVERSION.API.CACHE.GET_LOG}?taskId=${taskId}`;
  return HttpClient.get(url).pipe(
    map((res) => res as TaskLog[])
  );
}

  getFileInfoByBaseFiles(
    baseFiles: { baseFileId: string }[]
  ): Observable<FileInfoResponse[]> {
    const url = `${this.getHost(this.ApiHost)}/${SystemConstants.SERVER_CONVERSION.API.CACHE.POST}/info`;

    return HttpClient.post(url, baseFiles).pipe(
      map((res) => res as FileInfoResponse[])
    );
  }


  uploadFile(data: any, path: string): Observable<string> {
    const url = `${this.getHost(this.ApiHost)}/${
      SystemConstants.SERVER_CONVERSION.API.FILE.UPLOAD
    }?path=${path}`;

    return HttpClient.upload(url, data).pipe(map((res) => res as string));
  }

  clearFileCached(id: string): Observable<number> {
    const newHeaders = { Accept: "text/plain" };
    const api = SystemConstants.SERVER_CONVERSION.API.CACHE.DELETE(id);
    const url = `${this.getHost(this.ApiHost)}/${api}`;

    return HttpClient.delete(url, { headers: newHeaders }).pipe(
      map((res) => res as number)
    );
  }

  addFolder(path: string): Observable<boolean> {
    const data = ``;
    const api = `${SystemConstants.SERVER_CONVERSION.API.FILE.ADD}?path=${path}`;
    const url = `${this.getHost(this.ApiHost)}/${api}`;

    return HttpClient.post(url, data).pipe(map((res) => res as boolean));
  }

  uploadThumnail(file: FileInfo, thumnailSrc: string): Observable<unknown> {
    const pathObj = {
      baseFileId: file.baseFileId,
      majorVersion: file.baseMajorRev ? file.baseMajorRev.toString() : "0",
      minVersion: file.baseMinorRev ? file.baseMinorRev.toString() : "0",
    };
    const formData = new FormData();
    formData.append(
      "file",
      Utils.DataURIToBlob(thumnailSrc),
      `${Utils.getFileNameWithoutExtension(file.filename)}.png`
    );
    const param = Utils.parseUrl(pathObj);
    const api = `${
      SystemConstants.SERVER_STREAM.API.THUMNAIL.UPLOAD
    }?${param.toString()}`;
    const url = `${this.getHost(this.ApiHost)}/${api}`;

    return HttpClient.upload(url, formData).pipe(map((res) => res));
  }
}

export const ConversionApi = new ConversionApiController();
